import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null = checking, false = anon, object = authed
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(
    () => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false)).finally(() => setLoading(false)),
    []
  );

  useEffect(() => {
    // Returning from Google OAuth: let AuthCallback exchange the session first.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const finishAuth = (u) => { setUser(u); setLoading(false); };
  const logout = async () => { try { await api.post("/auth/logout"); } catch (e) { /* ignore */ } setUser(false); };

  return (
    <AuthContext.Provider value={{ user, loading, finishAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
